import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Save, Loader2, Warehouse } from 'lucide-react';
import { notesApi } from '@/lib/notesApi';
import { extractError } from '@/lib/errors';
import { TagMultiFilter } from './TagMultiFilter';

// Super admin: customers that are really the company's own stock, offered on every sales return.
export function TagStockCustomersAdmin() {
  const [customers, setCustomers] = useState([]);
  const [ids, setIds] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    notesApi.get('/notes/tag-workspace/customers').then(({ data }) => setCustomers(data || [])).catch(() => {});
    notesApi.get('/notes/tag-workspace/stock-customers').then(({ data }) => setIds((data.customers || []).map((c) => c.id))).catch(() => {});
  }, []);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await notesApi.put('/notes/tag-workspace/admin/stock-customers', { customer_ids: ids });
      setIds(data.customers.map((c) => c.id)); toast.success('Own-stock customers saved.');
    } catch (e) { toast.error(extractError(e, 'Could not save.')); } finally { setBusy(false); }
  };
  const name = (id) => customers.find((c) => c.id === id)?.name || id;
  return (
    <div className="space-y-4" data-testid="tagws-stock-customers">
      <div className="flex items-start gap-2"><Warehouse size={18} className="mt-0.5 text-primary" /><div><p className="text-sm font-semibold text-foreground">Own-stock customers</p><p className="text-xs text-muted-foreground">Customers that are really your own stock (e.g. STK). On every sales return the user picks one of these, or leaves it blank, and the returned pieces go back to stock under it. Pieces under these customers show no customer on the tags and are not counted as made for customers. They are weighed like any normal stock piece again (e.g. Dak Wt added back to net weight). The main portal order keeps its original customer.</p></div></div>
      <TagMultiFilter label="Own-stock customers" allLabel="None set" values={customers.map((c) => c.id)} fmt={name} value={ids} onChange={setIds} search testid="tagws-stock-customers-select" />
      <div className="flex flex-wrap gap-1.5" data-testid="tagws-stock-customers-list">
        {ids.length ? ids.map((id) => <span key={id} className="rounded-full border border-border bg-secondary px-2.5 py-1 text-xs font-medium">{name(id)}</span>) : <span className="text-xs text-muted-foreground">None set: sales returns just drop the customer.</span>}
      </div>
      <button type="button" onClick={save} disabled={busy} className="inline-flex h-9 items-center gap-1.5 rounded-lg bg-primary px-4 text-xs font-semibold text-primary-foreground disabled:opacity-60" data-testid="tagws-stock-customers-save">{busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Save</button>
    </div>
  );
}
